import { render, staticRenderFns } from "./IssueBadge.vue?vue&type=template&id=f3e2ca80&scoped=true"
import script from "./IssueBadge.vue?vue&type=script&lang=js"
export * from "./IssueBadge.vue?vue&type=script&lang=js"
import style0 from "./IssueBadge.vue?vue&type=style&index=0&id=f3e2ca80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e2ca80",
  null
  
)

export default component.exports